module.exports = __webpack_public_path__ + "static/media/saopaulo-categories.03ca7e45.csv";